import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // 統一的銀行進支記錄 API
    fetchBankRecords(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/finance/bank-records/", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    fetchBankRecord(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/finance/receipts/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    // 新增：銀行記錄相關 API
    updateSavingsStatus(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/finance/bank-records/update-savings-status", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    updateRemark(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/finance/bank-records/update-remark", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    getBankRecord(ctx, params) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/finance/bank-records/get-record", { params })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    // 新增雜項銀行進支記錄
    addMiscRecord(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/finance/bank-records/misc", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    // 刪除雜項銀行進支記錄
    deleteMiscRecord(ctx, { record_id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`/finance/bank-records/misc/${record_id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    }
  }
};
